import React from 'react';
import parse from 'html-react-parser';
import { useInputNumberGroup } from '../hooks';
import InputNumber from 'rsuite/InputNumber';
import OptionTitle from '../../OptionElements/OptionTitle';
import OptionDescription from '../../OptionElements/OptionDescription';
import OptionLabel from '../../OptionElements/OptionLabel';
import OptionFootnote from '../../OptionElements/OptionFootnote';

export default function OptionTypeInputNumber(props) {
  const {options} = props;
  const [, onChangeOptions] = useInputNumberGroup(props);

  return (
    <div className="app-option-list">
      {options.map((option, optionIndex) => {
        const {
          id,
          label,
          labelTooltip,
          title,
          description,
          footnote,
          quantityTitle,
          quantityValue,
          quantityValueMin,
          quantityValueMax,
          customClass = '',
          isDisabled = false
        } = option;

        return (
          <div className={`app-option-item ${customClass}`} key={id}>
            <OptionTitle title={title} />
            <OptionDescription description={description} />
            <OptionLabel
              label={label}
              labelTooltip={labelTooltip}
            />
            <div className="app-option-input-number">
              {quantityTitle && <div>{parse(quantityTitle)}</div>}
              <InputNumber
                value={quantityValue}
                min={quantityValueMin}
                max={quantityValueMax}
                disabled={isDisabled}
                onChange={(value, event) => onChangeOptions(value, event, optionIndex)}
              />
            </div>
            <OptionFootnote footnote={footnote} />
          </div>
        )
      })}
    </div>
  )
}
